<input
  #checkboxInput
  type="checkbox"
  [name]="item.label"
  [id]="item.label"
  class="form-check-input"
  [checked]="checked"
  (change)="toggleCheckbox($event)"
/><span *ngIf="item.label !== agreementType.SUBSCRIPTION"
  >{{ prefix + "accept" | msg | async }}{{ " " }}</span
>
<label [for]="item.label"
  ><a
    *ngIf="item.document"
    class="document-link"
    [href]="item.document"
    target="_blank"
    >{{ prefix + item.label | msg | async }}</a
  >
  <span *ngIf="!item.document">{{
    prefix + item.label | msg | async
  }}</span></label
>
<app-validation
  [hidden]="!showValidation"
  [validationMessages]="[validationMessage]"
></app-validation>
